import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { VisitorGateService } from '../../../../service/visitor-pass/visitor-pass.service';
import { DatePipe } from '@angular/common';
import { environment } from '../../../../../environments/environment';
import { jsPDF } from 'jspdf';
import * as QRCode from 'qrcode';
import { GateOutService } from '../../../../service/gate-out/gate-out-service';

@Component({
  selector: 'app-visitor-gate-out-pass',
  templateUrl: './visitor-gate-out-pass.component.html',
  styleUrl: './visitor-gate-out-pass.component.scss'
})
export class VisitorGateOutPassComponent {
  @ViewChild('fileInput')
  fileInput!: ElementRef;

  showFileUpload: boolean = true;
  vendorImageFile: File | null = null;
  FRAPPE_API_URL = environment.FRAPPE_API_URL
  isDownload: boolean = false
  responseValues: any[] = [];
  getAllVisitorPassList: any[] = [];
  generated_visitor_pass!: string
  gatePassInPhoto!: string

  visitorgatepass!: FormGroup

  constructor(
    private fb: FormBuilder,
    public messageService: MessageService,
    private visitorGateService: VisitorGateService,
    private gateOutService: GateOutService,
    private datePipe: DatePipe,
  ) { }


  ngOnInit() {
    this.visitorgatepass = this.fb.group({
      gate_pass_no:[''],
      date_and_time:[''],
      visitor_name:[''],
      visitor_mobile_no:[''],
      card_no:[''],
      no_of_persons:[''],
      organization_name:[''],
      address1:[''],
      address2:[''],
      pin_code:[''],
      city:[''],
      state:[''],
      district:[''],
      country:[''],
      vehicle_no:[''],
      material:[''],
      description:[''],
      mobile_no:[''],
      person_to_meet:[''],
      department:[''],
      designation:[''],
      purpose:[''],
      document_type:[''],
      document_no:[''],
      photo:[''],
      gate_out_time:['',Validators.required]

    });

    this.gateOutService.getAllVisitorPassDetail().then((res)=>{

      this.getAllVisitorPassList=res.message.get_all_visitor_pass
    }).catch((e)=>{
      console.log(e)
    })

  }

  onVisitorPassNoSelected(data:any){
    const formattedDate = this.datePipe.transform(data.date_and_time, 'dd/MM/yyy HH:mm')
    this.visitorgatepass.get('document_no')?.setValue(data.document_no)
    this.visitorgatepass.get('gate_out_time')?.setValue(data.gate_out_time)
    this.visitorgatepass.get('photo')?.setValue(data.photo)
    this.visitorgatepass.get('document_type')?.setValue(data.document_type)
    this.visitorgatepass.get('purpose')?.setValue(data.purpose)
    this.visitorgatepass.get('designation')?.setValue(data.designation)
    this.visitorgatepass.get('department')?.setValue(data.department)
    this.visitorgatepass.get('person_to_meet')?.setValue(data.person_to_meet)
    this.visitorgatepass.get('mobile_no')?.setValue(data.mobile_no)
    this.visitorgatepass.get('description')?.setValue(data.description)
    this.visitorgatepass.get('material')?.setValue(data.material)
    this.visitorgatepass.get('vehicle_no')?.setValue(data.vehicle_no)
    this.visitorgatepass.get('country')?.setValue(data.country)
    this.visitorgatepass.get('district')?.setValue(data.district)
    this.visitorgatepass.get('state')?.setValue(data.state)
    this.visitorgatepass.get('city')?.setValue(data.city)
    this.visitorgatepass.get('pin_code')?.setValue(data.pin_code)
    this.visitorgatepass.get('address2')?.setValue(data.address2)
    this.visitorgatepass.get('address1')?.setValue(data.address1)
    this.visitorgatepass.get('organization_name')?.setValue(data.organization_name)
    this.visitorgatepass.get('no_of_persons')?.setValue(data.no_of_persons)
    this.visitorgatepass.get('card_no')?.setValue(data.card_no)
    this.visitorgatepass.get('visitor_mobile_no')?.setValue(data.visitor_mobile_no)
    this.visitorgatepass.get('visitor_name')?.setValue(data.visitor_name)
    this.visitorgatepass.get('date_and_time')?.setValue(formattedDate)
    this.visitorgatepass.get('gate_pass_no')?.setValue(data.gate_pass_no)

  }



  async generatePdfWithQRCode() {
    const doc = new jsPDF();

    // QR Code Generation
    const qrText = `Visitor Pass Out No: ${this.generated_visitor_pass}`;
    const qrCodeDataUrl = await QRCode.toDataURL(qrText);
    const qrCodeSize = 30;
    const margin = 10;
    doc.addImage(qrCodeDataUrl, 'PNG', margin, margin, qrCodeSize, qrCodeSize);

    // Print Token number next to the QR code
    const tokenText = `Visitor Pass Out: ${this.generated_visitor_pass}`;
    const tokenTextX = margin + qrCodeSize + margin;
    const tokenTextY = margin + qrCodeSize / 2 + 5;
    doc.text(tokenText, tokenTextX, tokenTextY);

    // Fetch and add the visitor image in the top-right corner
    const photoUrl = this.gatePassInPhoto;
    if (photoUrl) {
      try {
        const imageResponse = await fetch(photoUrl);
        const imageBlob = await imageResponse.blob();
        const imageUrl = await new Promise<string>((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result as string);
          reader.onerror = error => reject(error);
          reader.readAsDataURL(imageBlob);
        });

        // Calculate image position to be in the top-right corner
        const imageSize = 40; // Set the size of the image (width and height)
        const imageX = doc.internal.pageSize.getWidth() - imageSize - margin; // Position from the right edge
        const imageY = margin; // Margin from the top

        doc.addImage(imageUrl, 'JPEG', imageX, imageY, imageSize, imageSize);
      } catch (error) {
        console.error('Error fetching or adding image:', error);
      }
    }

    // Set starting position for dynamic fields
    let yPos = margin + qrCodeSize + margin * 2;
    const lineHeight = 6.5;
    const fieldWidth = 60;

    // Set page borders
    doc.setDrawColor(0);
    doc.setLineWidth(0.2);
    doc.rect(5, 5, doc.internal.pageSize.getWidth() - 10, doc.internal.pageSize.getHeight() - 10, 'S');
    doc.setFontSize(10);
    // Add form values to PDF in table form (excluding 'generated_token_no' and 'photo')
    for (const [key, value] of Object.entries(this.responseValues)) {
      if (key !== 'generated_visitor_pass' && key !== 'photo') {
        const formattedFieldName = key.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        doc.text(`${formattedFieldName}:`, 10, yPos);
        doc.text(`${value}`, 80, yPos);
        doc.line(10, yPos + 2, doc.internal.pageSize.getWidth() - 10, yPos + 2); // Extend line till the end of the page
        yPos += lineHeight;
        yPos += 2; // Extra spacing after the line
      }
    }
    const pageHeight = doc.internal.pageSize.getHeight();
    const signatureBoxHeight = 20; // Height of the signature box
    const boxMargin = 5; // Margin around the signature box
    const signatureBoxY = pageHeight - signatureBoxHeight - boxMargin; // Y position of the signature box
    const signatureBoxWidth = doc.internal.pageSize.getWidth() - 2 * boxMargin; // Width of the signature box
    doc.rect(boxMargin, signatureBoxY, signatureBoxWidth, signatureBoxHeight, 'S'); // Draw the signature box
    doc.text('Signature:', boxMargin + 2, signatureBoxY + 7); // Label for the signature box
    // Save the PDF
    doc.save('Visitor-Pass-Out.pdf');
    this.visitorgatepass.reset();
    this.resetAfterDownload();
  }


  parseDateString(dateString: any): Date | null {
    if (typeof dateString === 'string' && dateString.length > 0) {
        const [day, month, yearAndTime] = dateString.split('/');
        const [year, time] = yearAndTime.split(' ');
        const [hours, minutes] = time.split(':');
        return new Date(Number(year), Number(month) - 1, Number(day), Number(hours), Number(minutes));
    }
    return null;
}




  onSubmit(){
    const uploadPromises = [];

    // if (this.vendorImageFile) {
    //   const vendorimageUploadDetails = {
    //     is_private: "1",
    //     folder: "Home",
    //     file_url: `/private/files/${this.vendorImageFile.name}`,
    //     doctype: "Visitor Gate Pass",
    //     docname: this.visitorgatepass.value.visitor_name,
    //     fieldname: "photo"
    //   };
    //   const path = `${this.FRAPPE_API_URL}/api/method/upload_file`;
    //   uploadPromises.push(this.visitorGateService.uploadFile(path, this.vendorImageFile, vendorimageUploadDetails).toPromise());
    // }
    // Promise.all(uploadPromises).then(uploadResponses => {
    if (this.visitorgatepass.valid) {
      const rawDate = this.visitorgatepass.get('date_and_time')?.value;
      const rawGateOutTime = this.visitorgatepass.get('gate_out_time')?.value;

      const dateObj = this.parseDateString(rawDate);

      const formattedDate = this.datePipe.transform(dateObj, 'yyyy-MM-dd HH:mm:ss');
      const formattedDate1 = this.datePipe.transform(rawGateOutTime, 'yyyy-MM-dd HH:mm:ss');


      const data1= this.visitorgatepass.value
      data1.date_and_time = formattedDate
      data1.gate_out_time = formattedDate1
      const data = {
        ...data1
      };
      this.responseValues = data;
      this.visitorGateService.createVisitorGateOutPass(data).then((_response) => {
        this.generated_visitor_pass = _response.message.data.name;
        this.gatePassInPhoto = _response.message.data.photo;
        this.isDownload = true;
        this.visitorgatepass.reset();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data submitted successfully!' });
      }).catch((error) => {
        console.error('Submission error:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Submission failed. Please try again.' });
      });

    } else {
      this.visitorgatepass.markAllAsTouched();
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill in all required fields correctly.' });
    }
  // });
  }
  resetAfterDownload() {
    this.isDownload = false;
    this.visitorgatepass.reset();
    this.showFileUpload = false;
    setTimeout(() => this.showFileUpload = true, 0);
  }


}
